module.exports = "/images/global.png?a073a81fd09e6117f3c350b1df878bc2";